"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const updateControlsArrayByPath_1 = __importDefault(require("./updateControlsArrayByPath"));
const updatePageTopNavControlByInfo = ({ // eslint-disable-line
topNavigationBar, controlInfo, dataToUpdate, shouldNotResetDynamicLoadingEnabled, }) => {
    const { context: { pageId }, path = [] } = controlInfo;
    if (!pageId) {
        throw new Error('No pageId found in context');
    }
    const { controls, updatedControls } = (0, updateControlsArrayByPath_1.default)({
        controls: topNavigationBar.controls || [],
        path,
        dataToUpdate,
        shouldNotResetDynamicLoadingEnabled,
    });
    const newTopNavigationBar = Object.assign(Object.assign({}, topNavigationBar), { controls });
    return { topNavigationBar: newTopNavigationBar, updatedPageId: pageId, updatedControls };
};
exports.default = updatePageTopNavControlByInfo;
